import { Autocomplete, Avatar, Box, Card, CardContent, Chip, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, ThemeProvider, colors, createTheme, styled, Divider } from '@mui/material'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import PersonIcon from '@mui/icons-material/Person';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import background from '../../../assests/images/mayaccountbg.png'
import EditIcon from '@mui/icons-material/Edit';
import { Images } from '../../../assests';
import { CssBaseline, Container, Paper, Typography, Stepper, Step, StepLabel, Button, TextField, List, ListItem, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Moveable from 'react-moveable';
import { ContextMenuTrigger } from 'react-contextmenu';
import { PDFExport } from '@progress/kendo-react-pdf';
import domtoimage from 'dom-to-image';


import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,

    IconButton,
} from '@mui/material';
import Input from '@mui/material/Input';
import { Add, Remove } from '@mui/icons-material';
import { SecondaryButton } from '../../../components/Buttons';
import PropTypes from 'prop-types';
import InputPhone from '../../../components/PhoneInput';
import { Controller, useForm } from 'react-hook-form';
import { IMaskInput } from 'react-imask';
import axios from 'axios';
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import moment from 'moment/moment';
import OrderServices from '../../../services/OrderServices';
import Swal from 'sweetalert2';
import AuthServices from '../../../services/AuthServices';
import { auth, provider, signInWithPopup } from '../../../config/firebase.config'; // Adjust the import path according to your file structure
import { getAuth, GoogleAuthProvider, signOut } from 'firebase/auth';
import html2canvas from 'html2canvas';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { AuthContext } from '../../../Context/AuthContext';
import Colors from '../../../assests/style';
import { CartContext } from '../../../Context/CartContext';
import { currencyType } from '../../../utils';

const steps = ['Shipping address', 'Checkout'];
const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="0000-0000-0000-0000"
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};





export default function Checkout() {

    const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, control: control1, watch, reset, setValue: setValue1, getValues: getValues1 } = useForm();
    console.log(errors1, 'errors1errors1errors1')
    const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, control: control2, setValue: setValue2, getValues: getValues2 } = useForm();
    const auth = getAuth();
    const { cartVisible, toggleCartVisibility } = useContext(CartContext);
    let User = localStorage.getItem('user')
    User = JSON.parse(User)
    let Vendor = localStorage.getItem('merchant')
    Vendor = JSON.parse(Vendor)
    let Order = localStorage.getItem('orderData')
    Order = JSON.parse(Order)
    console.log(Order, 'orderDatas');
    const [selectedTab, setSelectedTab] = useState(0)
    const Tabs = [{ id: 0, name: 'My Account', icon: <PersonIcon /> }, { id: 1, name: 'My Library', icon: <SaveAltIcon /> }, { id: 2, name: 'Addresses', icon: <LocationOnOutlinedIcon /> }, { id: 3, name: 'Account Settings', icon: <SettingsIcon /> }, { id: 4, name: 'Log out', icon: <LogoutIcon /> }]

    const { state } = useLocation();
    console.log(state);
    const navigate = useNavigate();
    const contentRef = useRef(null);
    const parentRef = useRef(null);
    const { user, setUser } = useContext(AuthContext);
    const [screenshotUrl, setScreenshotUrl] = useState()
    const pdfExportComponentFront = useRef(null);
    const pdfExportComponentBack = useRef(null);
    const elementFront = useRef(null)
    const elementBack = useRef(null)
    const [frontSSUrl, setFrontSSUrl] = useState()
    const [backSSUrl, setbackSSUrl] = useState()
    console.log(state);
    const [isLessThan1200, setIsLessThan1200] = useState(window.innerWidth < 1000);

    const [activeStep, setActiveStep] = useState(0);
    const [rotateDirection, setRotateDirection] = useState(false)
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [checkOut, setCheckOut] = useState(false)
    const [frontUrl, setFrontUrl] = useState()
    const [backUrl, setBackUrl] = useState()
    const [tshirtPrice, setTshirtPrice] = useState(0)
    const [maxOrder, setMaxOrder] = useState(0)
    const [deliveryCharges, setDeliveryCharges] = useState(0)
    // *For Stepper Forms Data
    const [step1FormData, setStep1FormData] = useState();
    const [step2FormData, setStep2FormData] = useState();
    const [orderSummary, setOrderSummary] = useState([])
    const [userData, setUserData] = useState()
    const [emirates, setEmirates] = useState([])
    const [subTotal, setSubTotal] = useState(0)
    const [Vat, setVat] = useState(0)
    const [amountWithVat, setAmountWithVat] = useState(0)
    const [userProfileData, setUserProfileData] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [cartDetails, setCartDetails] = useState(null)
    const [totalAmount, setTotalAmount] = useState(0)
    const [discount, setDiscount] = useState(0)
    const [selectedCity, setSelectedCity] = useState(null)
    const [selectedType, setSelectedType] = useState({ key: 'standard', ...Vendor?.shipping['standard'] });

    const stateOptions = [
        { _id: "New York", emirate: "New York", charge: 2 },
        { _id: "California", emirate: "California", charge: 0 },
        { _id: "Texas", emirate: "Texas", charge: 2 },
        { _id: "Florida", emirate: "Florida", charge: 2 },
        { _id: "Illinois", emirate: "Illinois", charge: 2 },
        { _id: "Arizona", emirate: "Arizona", charge: 2 },
        { _id: "Pennsylvania", emirate: "Pennsylvania", charge: 2 },
        { _id: "Ohio", emirate: "Ohio", charge: 2 },
        { _id: "Michigan", emirate: "Michigan", charge: 2 },
        { _id: "Georgia", emirate: "Georgia", charge: 2 },
    ];

    const cityOptions = [
        { id: "New York City", name: "New York City" },
        { id: "Los Angeles", name: "Los Angeles" },
        { id: "Chicago", name: "Chicago" },
        { id: "Houston", name: "Houston" },
        { id: "Phoenix", name: "Phoenix" },
        { id: "Philadelphia", name: "Philadelphia" },
        { id: "Dallas", name: "Dallas" },
        { id: "Atlanta", name: "Atlanta" },
        { id: "Miami", name: "Miami" },
        { id: "Detroit", name: "Detroit" },
    ];
    const handleChange3 = (event) => {
        const selectedKey = event.target.value;


        // ✅ Get the full object for the selected shipping type
        const selectedObj = { key: selectedKey, ...Vendor?.shipping[selectedKey] };

        setSelectedType(selectedObj);

        console.log("Selected Shipping Option:", selectedObj);
    };


    const ExpiryDate = React.forwardRef(function ExpiryDate(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="00/00"
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value) => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    });



    const CVV = React.forwardRef(function CVV(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="0000"
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value) => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    });



    const [selectedOption, setSelectedOption] = useState('');
    const [selectedState, setSelectedState] = useState(null)


    const divRef = useRef(null);
    const divRefBack = useRef(null);


    const capture = async () => {
        const div = divRef.current;

        if (divRef.current) {
            const a4Width = 210; // mm
            const a4Height = 297; // mm
            const scale = 10; // adjust this value to change the image resolution

            // Set the div's styles to match the A4 size
            div.style.width = `${a4Width}mm`;
            div.style.height = `${a4Height}mm`;
            div.style.padding = '0';
            div.style.border = 'none';
            div.style.overflow = 'hidden';

            // Capture the screenshot
            domtoimage.toPng(div, {
                bgcolor: 'transparent',
                width: a4Width * scale,
                height: a4Height * scale,
                style: {
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                },
            }).then(dataUrl => {
                const link = document.createElement('a');
                link.download = 'yImage.png';
                link.href = dataUrl;
                sendBlobFront(dataUrl.split(";base64,")[1], moment().unix() + '_Front.png')


            });
        }
    };
    const captureBack = async () => {
        const div = divRefBack.current;

        if (divRefBack.current) {

            const a4Width = 210; // mm
            const a4Height = 297; // mm
            const scale = 10; // adjust this value to change the image resolution

            // Set the div's styles to match the A4 size
            div.style.width = `${a4Width}mm`;
            div.style.height = `${a4Height}mm`;
            div.style.padding = '0';
            div.style.border = 'none';
            div.style.overflow = 'hidden';

            // Capture the screenshot
            domtoimage.toPng(div, {
                bgcolor: 'transparent',
                width: a4Width * scale,
                height: a4Height * scale,
                style: {
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                },
            }).then(dataUrl => {
                const link = document.createElement('a');
                link.download = 'back.png';
                link.href = dataUrl;
                sendBlobBack(dataUrl.split(";base64,")[1], moment().unix() + '_Back.png')
            });
        }
    };
    const waitForImagesToLoad = () => {
        return new Promise((resolve) => {
            const imgElements = document.querySelectorAll('img'); // Update this selector as per your needs

            let loadedCount = 0;

            imgElements.forEach((img) => {
                if (img.complete) {
                    loadedCount++;
                } else {
                    img.onload = () => {
                        loadedCount++;
                        if (loadedCount === imgElements.length) {
                            resolve();
                        }
                    };
                }
            });

            if (loadedCount === imgElements.length) {
                resolve();
            }
        });
    };

    const captureScreenshot = async () => {
        await waitForImagesToLoad();
        await capture();
        await captureBack();
    };


    const handleGoogleLogin = async () => {

        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            console.log("User Info: ", user);


            authLogin(user?.reloadUserInfo, result)
            // Handle user info here (e.g., save to state, context, or redirect)
        } catch (error) {
            console.error("Error during Google login: ", error);
        }
    };

    const authLogin = async (sendData, result) => {
        console.log(sendData, 'data');
        try {
            let obj = {
                phone: '',
                google_id: sendData.localId,
                email: sendData.email,

                name: sendData.displayName
            }
            const data = await AuthServices.authLogin(obj)
            console.log(data);
            if (data.responseCode == 200) {

                localStorage.setItem('authToken', JSON.stringify(data?.data?.token))
                localStorage.setItem('user', JSON.stringify(sendData))
                let userInfo = localStorage.getItem('user')
                setUserData(JSON.parse(userInfo))
                setUser(result.user)
            }


        } catch (error) {
            JSON.Stringyfy(error)
        } finally {

        }
    }
    const handleChange = (event) => {
        console.log(event.target.value);

        setSelectedOption(event.target.value);

        const deliveryChargesresult = calculateDeliveryCharges(totalQuantity, event.target.value);
        // setDeliveryCharges(deliveryChargesresult)
        console.log(`The delivery charges for a quantity of ${totalQuantity} is ${deliveryChargesresult}`);
    };
    const handleChange2 = (event) => {
        console.log(event.target.value);

        setSelectedState(event.target.value);


    };
    const [states, setStates] = useState([])

    const getStates = async (country) => {
        try {
            let params = { country: process.env?.REACT_APP_COUNTRY };
            const { data } = await OrderServices.getStates(params);
            console.log(data, 'countries');
            setStates(
                data?.states?.map((item, index) => ({
                    id: index,
                    name: item
                }))
            );





        } catch (error) {
            console.log(error);
        } finally {
        }
    };
    const [cities, setCities] = useState([])

    const getCities = async (id) => {
        try {
            let params = {
                country: 'Pakistan',
                state: id

            };
            const { data } = await OrderServices.getCities(params);
            console.log(data, 'cities');
            setCities(
                data?.cities?.map((item, index) => ({
                    id: index,
                    name: item
                }))
            );




        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const names = [
        'Abu Dhabi',
        'Dubai',
        'Sharjah',
        'Ajman',
        'Umm Al Quwain',
        'Ras Al Khaimah',
        'Fujairah',

    ];
    const handleNext = () => {
        setActiveStep(activeStep + 1);
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };
    const sizes = ['Small', 'Medium', 'Large', 'Extra Large'];
    const [quantities, setQuantities] = useState({
        S: 0,
        M: 0,
        L: 0,
        XL: 0,
    });

    const placeOrder = async () => {
        console.log(selectedOption, 'selectedOption');
        const merchant = JSON.parse(localStorage.getItem("merchant")) || {};
        const printingMethod = null;
        const state = localStorage.getItem("state") || "";
        const city = localStorage.getItem("city") || "";
        try {
            let obj = {
                ...step1FormData,
                vendor_id: merchant?._id,
                fabric: merchant?.selectedFabric,
                printing_method: printingMethod,
                state: state,
                city: city,
                shipping_type: selectedType?.key,
                delivery_charges: deliveryCharges,
                additional_request: getValues1('additionalRequest'),
                customer: {
                    name: getValues1('firstName'),

                    phone: getValues1('mobile'),
                }
                ,
                address: {
                    address_1: getValues1('address1'),
                    address_2: getValues1('address2'),
                    zip_code: getValues1('zip'),
                    state: state,
                    city: city,
                    // emirate: selectedOption?.emirate,
                    // emirate_id: selectedOption?._id
                },
                code: discount ? getValues2('promo') : null


            }
            console.log(obj, 'obj');
            if (process.env.REACT_APP_COUNTRY == 'Pakistan') {

                const { data } = await OrderServices.placeOrder2(obj)
                console.log(data);
                if (data) {
                    // localStorage.setItem('designArray',[])
                    // toggleCartVisibility()
                    window.location.href = data?.url

                }
            }
            else {
                const { data } = await OrderServices.placeOrder(obj)
                console.log(data);
                if (data) {
                    // localStorage.setItem('designArray',[])
                    // toggleCartVisibility()
                    window.location.href = data?.url

                }
            }

        } catch (error) {
            console.log(error, 'error');
        } finally {
            localStorage.removeItem('orderData')
        }
    }
    const PromoCode = async () => {


        try {
            let obj = {

                code: getValues2('promo')




            }
            console.log(obj, 'obj');
            const { data } = await OrderServices.PromoCode(obj)
            console.log(data);
            if (data) {
                setDiscount(data?.discount_applied)
                setErrorMessage(null)


            }



        } catch (error) {
            console.log(error);
            setErrorMessage(error)
        } finally {

        }
    }
    const handleDelete = () => {
        setDiscount(0)

    }

    const CustomPaper = (props) => (
        <Paper
            {...props}
            sx={{
                backgroundColor: "#101a33", // Navy blue background
                color: "white",
                borderRadius: "10px",
                mt: 1, // small margin top
            }}
        />
    );
    const submitForm1 = async (formData) => {
        console.log(formData);
        let obj = {
            customer: {
                first_name: formData.firstName,
                last_name: formData.lastName,
                phone: formData.mobile,
            }
            ,
            address: {
                address_1: formData.address1,
                address_2: formData.address2,
                zip_code: formData.zip,
                emirate: selectedOption?.emirate,
                emirate_id: selectedOption?.emirate_id
            },
        }
        setStep1FormData(obj)



    }
    const submitForm2 = async (formData) => {
        console.log(formData);
        let obj = {
            customer: {
                first_name: formData.firstName,
                last_name: formData.lastName,
                phone: formData.mobile,
            }
            ,
            address: {
                address_1: formData.address1,
                address_2: formData.address2,
                zip_code: formData.zip,
                emirate: formData.city
            },
        }
        setStep2FormData(obj)


    }

    useEffect(() => {
        // set default values on mount
        setValue1("states", { _id: localStorage.getItem('state'), emirate: localStorage.getItem('state') });
        setValue1("cities", { _id: localStorage.getItem('city'), emirate: localStorage.getItem('city') });
    }, [setValue1]); // run once on mount
    const getPricing = async () => {
        try {
            let params = {

            }
            const { data } = await OrderServices.getPricing(params)
            console.log(data);
            setEmirates(data?.pricing?.delivery_charges)
            setTshirtPrice(data?.pricing?.standard_price)
            setMaxOrder(data?.pricing?.max_per_order)



        } catch (error) {
            console.log(error);
        } finally {

        }
    }
    const handleQuantityChange = (size, event) => {
        const value = event.target.value;
        console.log(value, 'asdasd');
        if (!isNaN(value) && value >= 0) {
            // Create a new variable to hold the updated quantities
            const updatedQuantities = {
                ...quantities,
                [size]: parseInt(value, 10),
            };

            // Set the state with the updated quantities
            setQuantities(updatedQuantities);

            // Prepare the order summary based on the updated quantities
            const details = Object.entries(updatedQuantities).map(([size, qty]) => ({
                size,
                qty,
                design: 'abc',
            }));

            console.log(details, 'detailsdetailsdetails');
            // Example usage:

            setOrderSummary(details);
        }
    };

    // useEffect(() => {
    //     let Order2 = localStorage.getItem('orderData')
    //     Order2 = JSON.parse(Order2)
    //     console.log(Order2, 'orderDatas');
    //     if (!Order2) {
    //         navigate('/')
    //     }
    // }, [])


    const theme = createTheme({
        typography: {
            fontFamily: 'Poppins, sans-serif'// You can change this to your preferred font
        },
        components: {
            MuiStepLabel: {
                styleOverrides: {
                    label: {
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontFamily: 'Poppins, sans-serif',
                        '&.Mui-active': {
                            color: '#ffffff',
                        },
                        '&.Mui-completed': {
                            color: '#ffffff',
                        },
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiInputBase-root': {
                            color: 'white', // Text color,
                            fontFamily: 'Poppins, sans-serif'
                        },
                        '& .MuiInputLabel-root': {
                            color: 'white', // Label color
                        },
                        '& .MuiInput-underline:before': {
                            borderBottomColor: 'white', // Underline color when unfocused
                        },
                        '& .MuiInput-underline:after': {
                            borderBottomColor: 'white', // Underline color when focused
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: 'white', // Border color when unfocused
                            },
                            '&:hover fieldset': {
                                borderColor: 'white', // Border color on hover
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'white', // Border color when focused
                            },
                        },
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        color: 'white', // Text color for input
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderColor: 'white', // Border color for input
                    },
                    root: {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white',
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: 'white', // Text color for label
                        borderColor: 'white',
                        '&.Mui-focused': {
                            color: 'white',
                        },
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        color: 'black', // Text color for menu items
                        backgroundColor: 'white', // Background color for menu items
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(255, 255, 255, 0.2)', // Background color for selected item
                        },
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)', // Background color for hover
                        },
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: 'white', // Color for dropdown arrow
                    },
                },
            },
        },
        palette: {
            primary: {
                main: '#1976d2',
            },
            background: {
                default: '#333333',
            },
        },

    });

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <>
                        <Typography className='heading-font' variant="h6" gutterBottom>
                            Shipping <Box className='heading-font' variant="h6" component={"span"}>address</Box>
                        </Typography>
                        <Box component="form" className="formData" onSubmit={handleSubmit1(placeOrder)}>
                            <Grid container spacing={3}>
                                {/* First Name Field */}
                                <Grid item xs={12} sm={6}>

                                    <TextField
                                        id="firstName"
                                        name="firstName"
                                        label={'Name'}
                                        InputLabelProps={{
                                            shrink: watch('firstName')
                                        }}

                                        variant="outlined"
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                            },
                                            "fieldset": {
                                                borderRadius: "15px"
                                            }

                                        }}
                                        {...register1("firstName", {
                                            required: "Firstname is Required",
                                        })}
                                        helperText={errors1?.firstName?.message}
                                        error={!!errors1?.firstName}
                                        fullWidth
                                        autoComplete="given-name"
                                    />
                                </Grid>



                                {/* Mobile Number Field */}
                                <Grid item xs={12} sm={6}>

                                    <TextField
                                        id="mobile"
                                        name="mobile"
                                        label={'Mobile Number'}
                                        type='number'
                                        InputLabelProps={{
                                            shrink: watch('mobile')
                                        }}
                                        variant="outlined"

                                        sx={{
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                                MozAppearance: 'textfield',
                                            },
                                            '& .MuiInputBase-input::-webkit-outer-spin-button, & .MuiInputBase-input::-webkit-inner-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                            },
                                            '& .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&:hover .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&.Mui-focused .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            "fieldset": {
                                                borderRadius: "15px"
                                            }
                                        }}
                                        {...register1("mobile", {
                                            required: "Please enter your mobile number.",
                                            pattern: {
                                                value: /^(?:\+92|0)3[0-9]{9}$/,
                                                message: "Please enter a valid Pakistani phone number (e.g. 03XXXXXXXXX or +923XXXXXXXXX)."
                                            }

                                        })}
                                        helperText={errors1?.mobile?.message}
                                        error={!!errors1?.mobile}
                                        fullWidth
                                        autoComplete="tel"
                                    />
                                </Grid>

                                {/* Address Line 1 Field */}
                                <Grid item xs={12} mt={2}>

                                    <TextField
                                        id="address1"
                                        name="address1"
                                        label={'Address Line 1'}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: watch('address1')
                                        }}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                            },
                                            '& .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&:hover .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&.Mui-focused .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            "fieldset": {
                                                borderRadius: "15px"
                                            }
                                        }}
                                        {...register1("address1", {
                                            required: "Address line 1 is Required",
                                        })}
                                        helperText={errors1?.address1?.message}
                                        error={!!errors1?.address1}
                                        fullWidth
                                        autoComplete="shipping address-line1"
                                    />
                                </Grid>

                                {/* Address Line 2 Field */}
                                <Grid item xs={12} mt={2}>

                                    <TextField
                                        id="address2"
                                        name="address2"
                                        label={'Address Line 2'}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: watch('address2')
                                        }}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                            },
                                            '& .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&:hover .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&.Mui-focused .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            "fieldset": {
                                                borderRadius: "15px"
                                            }
                                        }}
                                        {...register1("address2")}
                                        fullWidth
                                        autoComplete="shipping address-line2"
                                    />
                                </Grid>

                                {/* Zip/Postal Code Field */}


                                {/* Emirates Field */}

                                <>
                                    {/* State Dropdown */}
                                    {/* State Dropdown */}
                                    <Grid item xs={12} sm={6} mt={2}>
                                        <Controller
                                            name="states"
                                            control={control1}
                                            rules={{ required: "State is required" }}
                                            render={({ field, fieldState }) => (
                                                <Autocomplete
                                                    disabled
                                                    options={stateOptions}
                                                    PaperComponent={CustomPaper}
                                                    getOptionLabel={(option) => option?.emirate || ""}
                                                    value={field.value || null}
                                                    onChange={(e, newValue) => {
                                                        field.onChange(newValue);
                                                        setSelectedState(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="States"
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                            variant="outlined"
                                                            sx={{
                                                                input: { color: "#9e9e9e !important" },
                                                                label: { color: "#9e9e9e !important" },
                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                    WebkitTextFillColor: "#9e9e9e", // 👈 your gray color
                                                                    color: "#9e9e9e", // fallback for non-webkit browsers
                                                                    opacity: 1,
                                                                },
                                                                ".MuiOutlinedInput-root": {
                                                                    "& fieldset": {
                                                                        borderColor: "#9e9e9e !important",
                                                                        borderRadius: "15px",
                                                                    },
                                                                    "&.Mui-disabled": {
                                                                        "& fieldset": { borderColor: "#9e9e9e !important" },
                                                                        "& input": { color: "#9e9e9e !important" },
                                                                        "& .MuiAutocomplete-input": { color: "#9e9e9e !important" },
                                                                        "& .MuiAutocomplete-endAdornment": {
                                                                            color: "#9e9e9e !important",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* City Dropdown */}
                                    <Grid item xs={12} sm={6} mt={2}>
                                        <Controller
                                            name="cities"
                                            control={control1}
                                            rules={{ required: "City is required" }}
                                            render={({ field, fieldState }) => (
                                                <Autocomplete
                                                    disabled
                                                    options={stateOptions}
                                                    PaperComponent={CustomPaper}
                                                    getOptionLabel={(option) => option?.emirate || ""}
                                                    value={field.value || null}
                                                    onChange={(e, newValue) => {
                                                        field.onChange(newValue);
                                                        setSelectedCity(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="City"
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                            variant="outlined"
                                                            sx={{
                                                                input: { color: "#9e9e9e !important" },
                                                                label: { color: "#9e9e9e !important" },
                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                    WebkitTextFillColor: "#9e9e9e", // 👈 your gray color
                                                                    color: "#9e9e9e", // fallback for non-webkit browsers
                                                                    opacity: 1,
                                                                },
                                                                ".MuiOutlinedInput-root": {
                                                                    "& fieldset": {
                                                                        borderColor: "#9e9e9e !important",
                                                                        borderRadius: "15px",
                                                                    },
                                                                    "&.Mui-disabled": {
                                                                        "& fieldset": { borderColor: "#9e9e9e !important" },
                                                                        "& input": { color: "#9e9e9e !important" },
                                                                        "& .MuiAutocomplete-input": { color: "#9e9e9e !important" },
                                                                        "& .MuiAutocomplete-endAdornment": {
                                                                            color: "#9e9e9e !important",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>



                                    {/* City Dropdown */}
                                    {/* <Grid item xs={12} sm={6} mt={2}>
        <Controller
          name="city"
          control={control1}
          rules={{ required: "City is required" }}
          render={({ field, fieldState }) => (
            <Autocomplete
              options={cityOptions}
              PaperComponent={CustomPaper}
              getOptionLabel={(option) => option?.name || ""}
              value={field.value || null}
              onChange={(e, newValue) => {
                field.onChange(newValue);
                setSelectedCity(newValue); // keep local state synced
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="City"
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  variant="outlined"
                  sx={{
                    input: { color: "white" },
                    label: { color: "white" },
                    ".MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "white", borderRadius: "15px" },
                      "&:hover fieldset": { borderColor: "white" },
                      "&.Mui-focused fieldset": { borderColor: "white" },
                      backgroundColor: "#101a33",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <>
                  <li {...props} style={{ color: "white", backgroundColor: "#101a33" }}>
                    {option.name}
                  </li>
                  <Divider sx={{ backgroundColor: "white", opacity: 0.2 }} />
                </>
              )}
              sx={{
                "& .MuiAutocomplete-listbox": { backgroundColor: "#101a33" },
                "& .MuiAutocomplete-option": { color: "white" },
              }}
            />
          )}
        />
      </Grid> */}
                                </>

                                {console.log(Vendor, 'Vendor')
                                }
                                {/* <Grid item xs={12} sm={6} mt={2}>

                                    <FormControl fullWidth error={!!errors1?.emirates}>
                                        <InputLabel id="demo-simple-select-label">Emirates</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="emirates"
                                            label={'Emirates'}

                                            {...register1("emirates", {
                                                required: selectedOption ? false : "Emirates is Required",
                                            })}
                                            sx={{
                                                color: 'white',
                                                '.MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'white',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'white',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'white',
                                                },
                                                '.MuiSvgIcon-root': {
                                                    color: 'white',
                                                },
                                                "fieldset": {
                                                    borderRadius: "15px"
                                                }
                                            }}
                                            value={selectedOption}
                                            onChange={handleChange}
                                        >
                                            {emirates?.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option?.emirate}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors1?.emirates && (
                                            <FormHelperText sx={{ color: 'red' }}>
                                                {errors1.emirates.message}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid> */}
                                <Grid item xs={12} sm={6} mt={2}>

                                    <TextField
                                        id="zip"
                                        name="zip"
                                        label={'Zip/Postal Code'}
                                        type="number"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: watch('zip')
                                        }}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                                MozAppearance: 'textfield',
                                            },
                                            '& .MuiInputBase-input::-webkit-outer-spin-button, & .MuiInputBase-input::-webkit-inner-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                            },
                                            '& .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&:hover .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&.Mui-focused .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            "fieldset": {
                                                borderRadius: "15px"
                                            }
                                        }}
                                        {...register1("zip", {
                                            required: "Zip is Required",
                                        })}
                                        helperText={errors1?.zip?.message}
                                        error={!!errors1?.zip}
                                        fullWidth
                                        autoComplete="shipping postal-code"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} mt={2}>
                                    <Typography variant="subtitle1" color="white" gutterBottom>
                                        Select Shipping Type
                                    </Typography>

                                    <RadioGroup value={selectedType} onChange={handleChange3}>
                                        <Grid container spacing={2}>
                                            {Object.entries(Vendor?.shipping).map(([key, option]) => (
                                                <Grid item xs={12} sm={4} key={key}>
                                                    <Card
                                                        sx={{
                                                            borderRadius: "15px",
                                                            cursor: "pointer",
                                                            border:
                                                                selectedType?.key === key
                                                                    ? "2px solid #0EA5EA"
                                                                    : "1px solid #2c3e50",
                                                            backgroundColor:
                                                                selectedType?.key === key ? "#1e3a5f" : "#15273f",
                                                            transition: "0.2s ease",
                                                            "&:hover": {
                                                                boxShadow: "0 0 10px rgba(14,165,234,0.6)",
                                                            },
                                                        }}
                                                    >
                                                        <CardContent>
                                                            <FormControlLabel
                                                                value={key}
                                                                checked={selectedType?.key === key}
                                                                control={<Radio sx={{ color: "white" }} />}
                                                                label={
                                                                    <Grid container direction="column" spacing={0.5}>
                                                                        <Grid item>
                                                                            <Typography fontWeight="bold" color="white">
                                                                                {key.charAt(0).toUpperCase() + key.slice(1)}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <Typography variant="body2" color="gray">
                                                                                {option.days}
                                                                            </Typography>
                                                                        </Grid>

                                                                        <Grid item>
                                                                            <Typography variant="caption" color="white">
                                                                                Price: {currencyType[process.env.REACT_APP_CURRENCY]?.code} {Vendor?.operating_states?.includes(localStorage.getItem('city')) ? option.instate_price : option.outstate_price}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                }
                                                            />
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </RadioGroup>

                                    {errors1?.shippingType && (
                                        <Typography color="error" variant="caption">
                                            {errors1.shippingType.message}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid item xs={12} mt={2}>

                                    <TextField
                                        id="additionalRequest"
                                        name="additionalRequest"
                                        label={'Additional Request'}
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                        InputLabelProps={{
                                            shrink: watch('additionalRequest')
                                        }}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                            },
                                            '& .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&:hover .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            '&.Mui-focused .MuiInput-underline:before': {
                                                borderBottomColor: 'white',
                                            },
                                            "fieldset": {
                                                borderRadius: "15px"
                                            }
                                        }}
                                        {...register1("additionalRequest", {
                                            required: false,
                                        })}
                                        helperText={errors1?.additionalRequest?.message}
                                        error={!!errors1?.additionalRequest}
                                        fullWidth
                                        autoComplete="shipping address-line1"
                                    />
                                </Grid>
                            </Grid>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>

                                <Button
                                    variant="contained"
                                    type='submit'
                                    sx={{ color: '#101A33', textTransform: 'capitalize', fontWeight: 600, background: "linear-gradient(270deg, #0BD1D1 -88.59%, #0EA5EA 96.66%)", borderRadius: '14px' }}
                                // disabled={(frontUrl && backUrl) ? false : true}

                                >
                                    {'Place Order'}
                                </Button>

                            </Box>
                            <p style={{ textAlign: 'center', fontSize: '14px', fontFamily: 'Poppins, sans-serif', marginTop: '25px' }}>
                                By placing your order, you agree to our company{' '}
                                <a onClick={() => navigate('/termsandconditions')} style={{ color: Colors.secondary1, fontFamily: 'Poppins, sans-serif' }}>
                                    T&C's
                                </a>{' '}

                            </p>
                        </Box>




                    </>
                );
            case 1:
                return (
                    <>
                        asdas
                    </>
                );
            case 2:
                const products = [
                    { name: 'Product 1', desc: 'A nice thing', price: '$9.99' },
                    { name: 'Product 2', desc: 'Another thing', price: '$3.45' },
                    { name: 'Product 3', desc: 'Something else', price: '$6.51' },
                    { name: 'Product 4', desc: 'Best thing of all', price: '$14.11' },
                ];
                const addresses = ['1 Main St', 'Springfield', 'IL', '62704', 'USA'];
                const payments = [
                    { name: 'Card type', detail: 'Visa' },
                    { name: 'Card holder', detail: 'Mr John Smith' },
                    { name: 'Card number', detail: 'xxxx-xxxx-xxxx-1234' },
                    { name: 'Expiry date', detail: '04/2024' },
                ];

                return (
                    <>
                        <Typography className='heading-font' variant="h6" gutterBottom>
                            Order  <Box className='heading-font' variant="h6" component={"span"}>Summary</Box>
                        </Typography>
                        <List disablePadding>

                            {orderSummary?.length > 0 && orderSummary?.map((product) => (
                                <ListItem key={product.name} sx={{ py: 1, px: 0 }}>
                                    <ListItemText primary={product.size} />
                                    <Typography variant="body2">$ &nbsp;&nbsp;{product.qty * tshirtPrice}</Typography>
                                </ListItem>
                            ))}
                            <ListItem sx={{ py: 1, px: 0 }}>
                                <ListItemText primary="Sub Total" />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {totalQuantity * tshirtPrice}
                                </Typography>
                            </ListItem>
                            <ListItem sx={{ py: 1, px: 0 }}>

                                <ListItemText primary="Delivery Charges" />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {deliveryCharges}
                                </Typography>
                            </ListItem>
                            <ListItem sx={{ py: 1, px: 0 }}>

                                <ListItemText primary="Total Amount" />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {deliveryCharges + (totalQuantity * tshirtPrice)}
                                </Typography>
                            </ListItem>

                        </List>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                                    Shipping
                                </Typography>
                                <Typography gutterBottom>{step1FormData.address.address_1}</Typography>
                                <Typography gutterBottom>{step1FormData.address.address_2}</Typography>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={6}>
                                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                                    Payment details
                                </Typography>
                                <Grid container>
                                    {payments.map((payment) => (
                                        <React.Fragment key={payment.name}>
                                            <Grid item xs={6}>
                                                <Typography gutterBottom>{payment.name}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography gutterBottom>{payment.detail}</Typography>
                                            </Grid>
                                        </React.Fragment>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <SecondaryButton onClick={() => {

                                placeOrder()
                            }} className={'checkout-btn'} m={'20px'} p={"15px 30px"} fontWeight={'bold'} color={'white'} title={'Confirm Order'} />
                        </Box>
                    </>
                );
            default:
                throw new Error('Unknown step');
        }
    };
    const getCartData = async (sendData) => {
        console.log(sendData, 'data');
        try {
            let params = {

            }
            const { data } = await OrderServices.CartData(params)
            console.log(data?.cart?.designs);
            const extractedDetails = data?.cart?.designs?.flatMap(item =>
                item.details.map(detail => ({
                    ...detail,
                    generated_art: item.design_id.generated_art,
                    design_id: item.design_id?._id,
                    designs: item?.designs,
                }))
            );
            console.log(extractedDetails, 'extractedDetails');

            setCartDetails(extractedDetails)
            const { totalPrice, totalQty } = extractedDetails?.reduce(
                (acc, item) => {
                    acc.totalPrice += item.price * item.qty;
                    acc.totalQty += item.qty;
                    return acc;
                },
                { totalPrice: 0, totalQty: 0 }
            );
            console.log(extractedDetails,'extractedDetailsextractedDetails');

            setTotalAmount(totalPrice);
            setTotalQuantity(totalQty);
        } catch (error) {
            console.log(error);
        } finally {

        }
    }

    const userProfile = async (sendData) => {
        console.log(sendData, 'data');
        try {
            let params = {

            }
            const { data } = await OrderServices.userProfile(params)

            setUserProfileData(data?.details)

        } catch (error) {
            console.log(error);
        } finally {

        }
    }


    const sendBlobBack = async (base64, name) => {
        let obj = {
            document: base64,
            filename: name

        }

        try {
            const response = await axios.post(process.env.REACT_APP_BASE_URL + '/api/system/uploadDesign', obj);

            console.log('Upload successful:', response.data.data.path);
            setBackUrl(response.data.data.path)
        } catch (error) {
            console.error('Error uploading the file:', error);
        }
    };
    const sendBlobFront = async (base64, name) => {
        let obj = {
            document: base64,
            filename: name

        }

        try {
            const response = await axios.post(process.env.REACT_APP_BASE_URL + '/api/system/uploadDesign', obj);

            console.log('Upload successful:', response.data.data.path);
            setFrontUrl(response.data.data.path)

        } catch (error) {
            console.error('Error uploading the file:', error);
        }
    };

    function calculateDeliveryCharges(quantity, selected) {


        // Calculate the number of full maxOrder (5 items) and the remaining items
        const fullOrders = Math.floor(quantity / maxOrder);
        const remainingItems = quantity % maxOrder;
        console.log(fullOrders);
        console.log(remainingItems);
        console.log(selected, 'selected');
        let value = selected ? parseInt(selected?.charge) : parseInt(selectedOption?.charge)
        // Calculate the total delivery charges
        let deliveryChargesresult = fullOrders * value;
        console.log(deliveryChargesresult, 'deliveryChargesresult');
        // If there are any remaining items, add another delivery charge
        if (remainingItems > 0) {
            deliveryChargesresult += value;
        }
        deliveryChargesresult = selected ? parseInt(selected?.charge) : parseInt(selectedOption?.charge)
        //console.log(deliveryChargesresult, 'deliveryChargesresult2');
        // setDeliveryCharges(deliveryChargesresult)



        return deliveryChargesresult;
    }


    useEffect(() => {
        console.log(selectedType, 'selectedTypeselectedType');
        let city = localStorage.getItem('city')
        console.log(Vendor?.operating_states?.includes(city), 'selectedTypeselectedType');
        if (Vendor?.operating_states?.includes(city)) {
            setDeliveryCharges(selectedType?.instate_price)
        }
        else {
            setDeliveryCharges(selectedType?.outstate_price)
        }

    }, [selectedType, selectedState])

    useEffect(() => {
        const handleResize = () => {
            setIsLessThan1200(window.innerWidth < 1000);
            console.log(window.innerWidth < 1000);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        const total = Object.values(quantities).reduce((acc, quantity) => acc + (quantity || 0), 0);
        setTotalQuantity(total);

        const deliveryChargesresult = calculateDeliveryCharges(Order?.totalQuantity, null);
        // setDeliveryCharges(deliveryChargesresult)

    }, [quantities]);
    useEffect(() => {
        getStates()
        getPricing()
        if (state) {
            sendBlobFront(state?.frontSSUrl?.document, state?.frontSSUrl?.name)
            sendBlobBack(state?.backSSUrl?.document, state?.backSSUrl?.name)
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);


        // Assuming you have a fixed unit price, for example:
        const unitPrice = 15.00;
        let products = Order?.quantities
        // Adding unit_price to each object in the array
        const updatedProducts = products?.map(product => ({
            ...product,
            unit_price: unitPrice
        }));
        console.log(Order?.quantities);
        console.log(updatedProducts, 'updatedProducts');
        userProfile()
        getCartData()
    }, []);
    useEffect(() => {
        if (userProfileData) {
            console.log(userProfileData);
            const words = userProfileData?.name?.split(' ');

            // Assume the first word is the first name and the rest is the last name
            let lastName
            let firstName
            if (words.length == 1) {

                firstName = words.join(" ");

            }
            else {
                lastName = words[words.length - 1];
                words.pop();
                firstName = words.join(" ");
            }
            console.log();

            setValue1('firstName', firstName)
            setValue1('lastName', lastName)
            setValue1('mobile', userProfileData?.phone || null)
            setValue1('address1', userProfileData?.address_1)
            setValue1('address2', userProfileData?.address_2)
            setValue1('city', userProfileData?.emirate)
            let filterOption = emirates?.find((item => item?._id == userProfileData?.emirate_id))
            if (filterOption) {

                setSelectedOption(filterOption)
            }
            else {
                setSelectedOption(null)
            }
            let qty = Order?.quantities?.reduce((acc, item) => acc + item.qty, 0)
            console.log(Order, 'totalQuantity');
            console.log(maxOrder, 'maxOrder');
            const deliveryChargesresult = calculateDeliveryCharges(qty, filterOption);
            // setDeliveryCharges(deliveryChargesresult)
            // setValue1('zip', userProfileData?.zip_code)
            setValue1('emirates', userProfileData?.emirate)
        }
    }, [userProfileData, emirates])

    useEffect(() => {
        let total = parseFloat(((totalAmount || 0) + (deliveryCharges || 0)) - parseFloat(discount || 0))
        console.log(parseFloat(total * 0.05).toFixed(2), 'totaltotaltotal');

        setVat(parseFloat(total * 0.05).toFixed(2))
    }, [totalAmount, deliveryCharges, discount])



    return (
        <Fragment  >


            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '300px', // Adjust height as needed
                    display: 'flex',
                    alignItems: 'center', justifyContent: 'center'
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <p className='banner-text heading-font' style={{ fontSize: '35px', textAlign: 'center', fontFamily: "Noto Sans, sans-serif", }}> Checkout  </p>
                    {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
                </Box>
            </Box>

            <Grid container sx={{ py: 10 }} justifyContent={'center'} >


                <Grid item md={12} lg={12}>
                    <>

                        <ThemeProvider theme={theme}>


                            {/* <Box sx={{ width: '60%', margin: '0 auto', mb: '40px' }}>
                                <Stepper activeStep={1} alternativeLabel>
                                    {steps.map((label) => (
                                        <Step key={label}>
                                            <StepLabel sx={{ color: 'black' }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box> */}
                            <Grid gap={2} container sx={{ width: '80%', margin: '0 auto' }}>

                                <Grid item sm={12} md={7.5}>
                                    {<Container component="main" sx={{ width: '100%', backgroundColor: '#101A33', borderRadius: '15px' }}>
                                        <Paper sx={{ p: 2, backgroundColor: 'transparent', color: 'white', boxShadow: 'none' }}>


                                            {activeStep === steps.length ? (
                                                <Typography variant="h5" gutterBottom>
                                                    Thank you for your order.
                                                </Typography>
                                            ) : (
                                                <>
                                                    <Box sx={{ mt: 3 }}>
                                                        {getStepContent(activeStep)}

                                                    </Box>
                                                </>
                                            )}
                                        </Paper>
                                    </Container>}
                                </Grid>
                                <Grid item sm={12} md={4} sx={{ backgroundColor: '#101A33', borderRadius: '15px' }}>
                                    <Box sx={{ backgroundColor: '#101A33', p: 4, pb: 0 }}>
                                        <Typography className='heading-font' variant="h6" gutterBottom>
                                            Order  <Box className='heading-font' variant="h6" component={"span"}>Summary</Box>
                                        </Typography>
                                        <div style={{ color: '#fff' }}>

                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px', fontFamily: 'Poppins, sans-serif' }}>
                                                <span>Items ({cartDetails?.length})</span>
                                                <span>{currencyType[process.env.REACT_APP_CURRENCY]?.code} {totalAmount}</span>
                                            </div>

                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                                <span>Shipping :</span>
                                                <span>{currencyType[process.env.REACT_APP_CURRENCY]?.code} {isNaN(deliveryCharges) ? 0 : deliveryCharges}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                                <span>Discount :</span>
                                                <span>{currencyType[process.env.REACT_APP_CURRENCY]?.code} {(discount)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                                <span>Sub Total :</span>
                                                <span>{currencyType[process.env.REACT_APP_CURRENCY]?.code} {parseFloat(((totalAmount || 0) + (deliveryCharges || 0)) - parseFloat(discount || 0))}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', fontFamily: 'Poppins, sans-serif' }}>
                                                <span>VAT 5% :</span>
                                                <span>
                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {parseFloat(parseFloat(((totalAmount || 0) + (deliveryCharges || 0)) - parseFloat(discount || 0))) * 0.05}
                                                </span>
                                            </div>
                                            <hr style={{ borderColor: '#fff', margin: '20px 0' }} />
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Poppins, sans-serif', color: "rgba(11, 209, 209, 1)" }}>
                                                <span>Order Total:</span>
                                                <span>{currencyType[process.env.REACT_APP_CURRENCY]?.code} {parseFloat(((totalAmount || 0) + (deliveryCharges || 0)) - parseFloat(discount || 0)) + parseFloat(parseFloat(((totalAmount || 0) + (deliveryCharges || 0)) - parseFloat(discount || 0))) * 0.05}</span>
                                            </div>
                                            <hr style={{ borderColor: '#fff', margin: '20px 0' }} />

                                        </div>
                                    </Box>
                                    {<Container component="main" sx={{ width: '100%', backgroundColor: '#101A33', borderRadius: '8px', p: 4, pt: 0 }}>
                                        <Typography className='heading-font' variant="h6" gutterBottom>
                                            Promo <Box className='heading-font' component={"span"}> Code</Box>
                                        </Typography>
                                        {discount != 0 && (
                                            <Chip
                                                label={getValues2('promo')}
                                                onDelete={handleDelete}
                                                sx={{
                                                    mb: 2,
                                                    color: '#101A33',
                                                    background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)',
                                                    '& .MuiChip-deleteIcon': {
                                                        color: '#101A33', // Ensures delete icon is also white
                                                    },
                                                }}
                                            />
                                        )}

                                        <Box component={'form'} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }} onSubmit={handleSubmit2(PromoCode)}>
                                            <TextField
                                                disabled={discount}
                                                id="promo"
                                                name="promo"
                                                label={'Enter Promo Code'}

                                                variant="outlined"
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        color: 'white',
                                                    },
                                                    "fieldset": {
                                                        borderRadius: "15px"
                                                    }

                                                }}
                                                {...register2("promo", {
                                                    required: 'promo code is required',
                                                })}
                                                helperText={errors2?.promo?.message}
                                                error={!!errors2?.promo}
                                                fullWidth
                                                autoComplete="given-name"
                                            />

                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ color: '#101A33', textTransform: 'capitalize', p: '15px 30px', fontWeight: 600, background: "linear-gradient(270deg, #0BD1D1 -88.59%, #0EA5EA 96.66%)", borderRadius: "15px" }}
                                                disabled={discount}

                                            >
                                                Apply
                                            </Button>

                                        </Box>
                                        {errorMessage && <span style={{ color: '#d32f2f', fontSize: '10px' }}>{errorMessage}</span>}
                                    </Container>}
                                </Grid>

                            </Grid>
                        </ThemeProvider>
                    </>
                </Grid>
            </Grid>


        </Fragment>
    )
}
